export class TradeGroup {
    ID: number;
    Code: string;
    Name: string;
    FullName: string;
    Inactive: boolean;
}

export default TradeGroup;